<template>
  <div class="addedit-vessel">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2 class="pl-2">
          {{ editRoute ? $t("labels.edit_vessel") : $t("labels.add_vessel") }}
        </h2>
      </div>
    </div>

    <form @submit.prevent="checkValidation()" autocomplete="off">
      <vx-card class="addedit-vessel-card">
        <div class="vx-row w-full m-0 mb-4">
          <div class="vx-col sm: w-full md:w-1/2 mb-4 pl-0">
            <label>{{ $t("labels.name") }}</label>
            <vs-input
              v-validate="'required'"
              type="text"
              maxlength="50"
              class="w-full mt-1"
              name="name"
              v-model="name"
              icon-no-border
            />
            <span class="text-danger text-sm">{{ errors.first("name") }}</span>
          </div>
          <div class="vx-col sm: w-full type md:w-1/2 mb-4 pr-0">
            <label>{{ $t("labels.imo_number") }}</label>
            <vs-input
              v-validate="'required|alpha_num'"
              type="text"
              maxlength="7"
              class="w-full mt-1"
              name="imo_number"
              v-model="imo_number"
              icon-no-border
            />
            <span class="text-danger text-sm">{{
              errors.first("imo_number")
            }}</span>
          </div>
          <vs-popup
            class="holamundo popup-1"
            :title="$t('labels.owner')"
            :active.sync="ownerPopupActive"
          >
            <add-vessel-client
              client-type="OW"
              @closePopup="closePopup"
            ></add-vessel-client>
          </vs-popup>
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full md:w-1/2 pl-0">
              <div class="flex justify-between">
                <label class="self-end">{{ $t("labels.owner") }}</label>
                <vs-button
                  type="filled"
                  color="primary"
                  button="button"
                  class="login-btn px-4 py-2"
                  @click="createNewClient('OW')"
                  >+</vs-button
                >
              </div>
              <v-select
                v-model="owner"
                :options="owners"
                :reduce="(owners) => owners.id"
                name="owner"
                :value="$store.myValue"
                @input="setSelectedOwner"
                label="name"
                class="mt-1"
              />
              <!--              <span class="text-danger text-sm">{{ errors.first('owner') }}</span>-->
            </div>
            <div class="vx-col sm: w-full md:w-1/2 mt-4 md:mt-0 pr-0">
              <vs-popup
                class="holamundo popup-1"
                :title="$t('labels.manager')"
                :active.sync="managerPopupActive"
              >
                <add-vessel-client
                  v-if="owner"
                  client-type="M"
                  :owner-id="owner"
                  @closePopupManager="closePopupManager"
                ></add-vessel-client>
              </vs-popup>
              <div class="flex justify-between">
                <label class="self-end">{{ $t("labels.manager") }}</label>
                <vs-button
                  :disabled="managerActive"
                  type="filled"
                  color="primary"
                  button="button"
                  class="login-btn px-4 py-2"
                  @click="createNewClient('M')"
                  >+</vs-button
                >
              </div>
              <v-select
                v-model="manager"
                :options="managers"
                name="manager"
                :reduce="(managers) => managers.id"
                label="name"
                class="mt-1"
              />
              <!--              <span class="text-danger text-sm">{{ errors.first('manager') }}</span>-->
            </div>
          </div>
          <vs-popup
            class="holamundo popup-1"
            :title="$t('labels.office')"
            :active.sync="officePopupActive"
          >
            <add-vessel-client
              v-if="manager && owner"
              client-type="OF"
              :owner-id="owner"
              :manager-id="manager"
              @closePopupOffice="closePopupOffice"
            ></add-vessel-client>
          </vs-popup>
          <div class="vx-row w-full m-0 mt-4">
            <div class="vx-col sm: w-full md:w-1/2 pl-0">
              <div class="flex justify-between">
                <label class="self-end">{{ $t("labels.office") }}</label>
                <vs-button
                  :disabled="officeActive"
                  type="filled"
                  color="primary"
                  button="button"
                  class="login-btn px-4 py-2"
                  @click="createNewClient('OF')"
                  >+</vs-button
                >
              </div>
              <v-select
                v-model="office"
                :options="offices"
                name="office"
                :reduce="(offices) => offices.id"
                label="name"
                class="mt-1"
              />
              <!--              <span class="text-danger text-sm">{{ errors.first('office') }}</span>-->
            </div>
            <div class="vx-col sm: w-full md:w-1/2 pr-0 sm: mt-4 md:mt-0">
              <vs-popup
                class="holamundo popup-1"
                :title="$t('labels.fleet')"
                :active.sync="fleetPopupActive"
              >
                <add-vessel-client
                  v-if="office && manager && owner"
                  client-type="F"
                  :owner-id="owner"
                  :manager-id="manager"
                  :office-id="office"
                  :fleet-id="fleet"
                  @closePopupFleet="closePopupFleet"
                ></add-vessel-client>
              </vs-popup>
              <div class="flex justify-between">
                <label class="self-end">{{ $t("labels.fleet") }}</label>
                <vs-button
                  :disabled="fleetActive"
                  type="filled"
                  color="primary"
                  button="button"
                  class="login-btn px-4 py-2"
                  @click="createNewClient('F')"
                  >+</vs-button
                >
              </div>
              <v-select
                v-model="fleet"
                :options="fleets"
                name="fleet"
                :reduce="(fleets) => fleets.id"
                label="name"
                class="mt-1"
              />
              <!--              <span class="text-danger text-sm">{{ errors.first('fleet') }}</span>-->
            </div>
          </div>
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full md:w-1/2 pl-0 mt-4">
              <label>{{ $t("labels.type") }}</label>
              <v-select
                v-model="parent_id"
                :options="parentVesselTypes"
                :reduce="(parentVesselTypes) => parentVesselTypes.id"
                :value="$store.myValue"
                @input="setSelectedVesselType"
                label="name"
                class="mt-1"
                v-validate="'required'"
              />
              <span class="parent_is_valid" v-if="!is_validation">
                Please select one of type
              </span>
              <!-- <span class="text-danger text-sm">{{
                errors.first("type")
              }}</span> -->
            </div>
            <div class="vx-col sm: w-full md:w-1/2 pr-0 mt-4">
              <label>{{ $t("labels.subtype") }}</label>
              <v-select
                v-model="subtype"
                :options="subtypes"
                :reduce="(subtypes) => subtypes.id"
                :value="$store.myValue"
                :label="'name'"
                name="subtype"
                class="mt-1"
                v-validate="'required'"
                @input="vesselSubTypeChange"
              />
              <!--              <span class="text-danger text-sm">{{ errors.first('subtype') }}</span>-->
            </div>
          </div>
          <div class="vx-row w-full m-0 mt-4">
            <div class="vx-col sm: w-full md:w-1/2 pl-0">
              <label>{{ $t("labels.flag") }}</label>
              <v-select
                v-model="country"
                :options="countries"
                :reduce="(countries) => countries.id"
                :value="$store.myValue"
                @input="selectedCountry"
                name="country"
                :label="'name'"
                class="mt-1"
              />
              <!--              <span class="text-danger text-sm">{{ errors.first('country') }}</span>-->
            </div>
            <div class="vx-col sm: w-full md:w-1/2 pr-0 sm: mt-4 md:mt-0">
              <label>{{ $t("labels.port") }}</label>
              <v-select
                v-model="port"
                :options="ports"
                :reduce="(ports) => ports.id"
                name="port"
                :label="'name'"
                class="mt-1"
              />
              <!--              <span class="text-danger text-sm">{{ errors.first('port') }}</span>-->
            </div>
          </div>
          <div
            class="vx-col w-full pl-0 pr-0 mt-6 flex sm: justify-center md:justify-start"
          >
            <label>{{ $t("labels.vessel_status") }}:</label>
            <vs-switch color="primary" v-model="is_active" class="ml-4">
              <span slot="on">Active</span>
              <span slot="off">Deactive</span>
            </vs-switch>
          </div>

          <div class="vx-col w-full m-0 mt-4" v-if="folders.length">
            <InspectionImage
              ref="inspectionImg"
              :sectionInfo="folders"
              :vesselSubTypeInfo="vesselSubTypeInfo"
              page="addEditVessel"
            />
          </div>
        </div>

        <div class="mt-2 flex justify-center">
          <vs-button
            type="filled"
            color="primary"
            id="vessel-add-edit"
            button="submit"
            class="login-btn"
            >{{
              editRoute ? $t("labels.update_vessel") : $t("labels.add_vessel")
            }}</vs-button
          >
        </div>
      </vx-card>
    </form>
  </div>
</template>
<script>
import Vue from "vue";
import AddVesselClient from "@/layouts/components/vessel-management/add-vessel-client";
import InspectionImage from "@/components/inspection-image.vue";
export default {
  components: {
    AddVesselClient,
    InspectionImage,
  },
  data() {
    return {
      parent_id: null,
      parentVesselTypes: [],
      name: "",
      selected_vesseltype: "",
      selected_owner: "",
      selected_country: "",
      owner: null,
      manager: null,
      office: null,
      fleet: null,
      owners: [],
      managers: [],
      offices: [],
      fleets: [],
      type: null,
      subtype: null,
      is_active: false,
      imo_number: null,
      port: null,
      country: null,
      countries: [],
      ports: [],
      subtypes: [],
      ownerPopupActive: false,
      managerPopupActive: false,
      officePopupActive: false,
      fleetPopupActive: false,
      managerActive: true,
      officeActive: true,
      fleetActive: true,
      is_validation: true,
      folders: [],
      vesselTypeInfo: null,
      vesselSubTypeInfo: null,
    };
  },
  watch: {
    owner(value) {
      if (value === null || value === "") {
        this.manager = null;
        this.managers = [];
      } else {
        this.managerActive = false;
        this.getManagers();
      }
    },
    manager(value) {
      if (value === null || value === "") {
        this.office = null;
        this.offices = [];
      } else {
        this.officeActive = false;
        this.getOffices();
      }
    },
    office(value) {
      if (value === null || value === "") {
        this.fleet = null;
        this.fleets = [];
      } else {
        this.fleetActive = false;
        this.getFleets();
      }
    },
    country(value) {
      if (value === null || value === "") {
        this.fleet = null;
        this.fleets = [];
      } else {
        this.getPorts();
      }
    },
    parent_id(value) {
      if (value === null || value === "") {
        this.subtype = null;
        this.subtypes = [];
      } else {
        this.getSubtypes();
      }
    },
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    },
  },
  async mounted() {
    this.setValidationMessage();
    this.getParentVesselTypes();
    this.getOwners();
    this.getCountries();
    if (this.editRoute) {
      this.getVessels();
      this.getVesselFolderSubFolders();
    }
  },
  methods: {
    async getVesselFolderSubFolders() {
      const response = await this.getHTTPGetResponse(
        `vessels/get/${this.editRoute}/folder/subfolder`
      );
      if (response) {
        if (response) {
          let data = response.data;
          if (data && data.folders) {
            if (data.folders.length) {
              this.folders = data.folders.map((folder) => ({
                id: folder.id,
                folder_name: folder.folder_name,
                ga_plan_image: folder.ga_plan_image,
                location: folder.location ? JSON.parse(folder.location) : null,
                subFolders:
                  folder.subFolders.map((subFolder) => ({
                    id: subFolder.id,
                    folder_name: subFolder.folder_name,
                    location: subFolder.location
                      ? JSON.parse(subFolder.location)
                      : null,
                  })) || [],
              }));

              this.currentFolderIndex = this.folders.length ? 0 : null;
              this.vesselTypeInfo = data.vessel_type;
              this.vesselSubTypeInfo = data.vessel_sub_type;
            } else {
              this.getFolderSubFolders();
            }
          }
        }
      }
    },
    async getFolderSubFolders() {
      const vessel_type_id = this.parent_id;
      const vessel_sub_type_id = this.subtype;
      let response = await this.getHTTPGetResponse(
        `/folders/subfolder/list?vessel_type_id=${vessel_type_id}&vessel_sub_type_id=${vessel_sub_type_id}`
      );

      if (response) {
        let data = response.data;
        if (data && data.folders) {
          this.folders = data.folders.map((folder) => ({
            folder_name: folder.folder_name,
            ga_plan_image: folder.ga_plan_image,
            location: folder.location ? JSON.parse(folder.location) : null,
            subFolders:
              folder.subFolders.map((subFolder) => ({
                folder_name: subFolder.folder_name,
                location: subFolder.location
                  ? JSON.parse(subFolder.location)
                  : null,
              })) || [],
          }));
          this.currentFolderIndex = this.folders.length ? 0 : null;
          this.vesselTypeInfo = data.vessel_type;
          this.vesselSubTypeInfo = data.vessel_sub_type;
        }
      }
    },
    checkValidation() {
      this.$validator.validate().then((result) => {
        if (this.parent_id == null) {
          this.is_validation = false;
        }
        if (result) {
          this.is_active = true;
          this.addEditVessel();
        }
      });
    },
    setSelectedVesselType(value) {
      if (this.parent_id != null) {
        this.is_validation = true;
      }
      //fist clear selected service and its dropdown array
      this.subtype = null;
      this.subtypes = [];
      //set current v -select value as a selected_con
      this.selected_vesseltype = value;

      // get services for selected cont
      let parentVesselTypes = this.parentVesselTypes;
      parentVesselTypes.filter(function (el) {
        return el.id == value;
      });
      let subtype_req = this.subtypes;
      let filteredSubTypes = [];
      for (var i = 0; i < subtype_req.length; i++) {
        let obj = { id: subtype_req[i].id, name: subtype_req[i].name };
        filteredSubTypes.push(obj);
      }
      this.subtypes = filteredSubTypes;
    },
    vesselSubTypeChange(value) {
      this.getFolderSubFolders();
    },
    setSelectedOwner(value) {
      //fist clear selected manager and its dropdown array
      this.manager = null;
      this.managers = [];
      //set current v -select value as a selected_owner
      this.selected_owner = value;

      // get managers for selected owner
      let owners = this.owners;
      owners.filter(function (el) {
        return el.id == value;
      });
      let manager_req = this.managers;
      let filteredManagers = [];
      for (var i = 0; i < manager_req.length; i++) {
        let obj = { id: manager_req[i].id, name: manager_req[i].name };
        filteredManagers.push(obj);
      }
      this.managers = filteredManagers;
    },
    selectedCountry(value) {
      //fist clear selected port and its dropdown array
      this.port = null;
      this.ports = [];
      //set current v -select value as a selected_country
      this.selected_country = value;

      // get services for selected cont
      let countries = this.selected_countries;
      countries.filter(function (el) {
        return el.id == value;
      });
      let port_req = this.subtypes;
      let filteredPorts = [];
      for (var i = 0; i < port_req.length; i++) {
        let obj = { id: port_req[i].id, name: port_req[i].name };
        filteredPorts.push(obj);
      }
      this.ports = filteredPorts;
    },
    async getOwners() {
      var input = {
        type: "CL",
        sub_type: "OW",
      };
      let response = await this.getHTTPPostResponse("/users", input);
      if (response) {
        let data = response.data.users;
        if (data.length > 0) {
          data.forEach((el) => {
            if (el.organisation_name) {
              el.name = el.name + " (" + el.organisation_name + ")";
            }
          });
        } else {
          this.owner = null;
        }
        this.owners = data;
      }
    },
    async getManagers() {
      let response = await this.getHTTPGetResponse("/users/get/" + this.owner);
      if (response) {
        let user = response.data.user;
        if (user && user.children.length > 0) {
          user.children.forEach((el) => {
            if (el.organisation_name) {
              el.name = el.name + " (" + el.organisation_name + ")";
            }
          });
        } else {
          this.manager = null;
        }
        this.managers = user.children;
        const owner = { ...user };
        delete owner.children;
        this.managers = [owner, ...this.managers];
      }
    },
    async getOffices() {
      let response = await this.getHTTPGetResponse(
        "/users/get/" + this.manager
      );
      if (response) {
        let user = response.data.user;
        if (user && user.children.length > 0) {
          user.children.forEach((el) => {
            if (el.organisation_name) {
              el.name = el.name + " (" + el.organisation_name + ")";
            }
          });
        } else {
          this.office = null;
        }
        this.offices = user.children;
        const owner = { ...user };
        delete owner.children;
        this.offices = [owner, ...this.offices];
      }
    },
    async getFleets() {
      let response = await this.getHTTPGetResponse("/users/get/" + this.office);
      if (response) {
        let user = response.data.user;
        if (user && user.children.length > 0) {
          user.children.forEach((el) => {
            if (el.organisation_name) {
              el.name = el.name + " (" + el.organisation_name + ")";
            }
          });
        } else {
          this.fleet = null;
        }
        this.fleets = user.children;
        const owner = { ...user };
        delete owner.children;
        this.fleets = [owner, ...this.fleets];
      }
    },
    async getCountries() {
      var input = {
        name: "",
        code: "",
      };
      let response = await this.getHTTPPostResponse("/country/list", input);
      if (response) {
        let data = response.data.countries;
        this.countries = data;
      }
    },
    async getPorts() {
      var input = {
        country_id: this.country,
      };
      let response = await this.getHTTPPostResponse("/ports/list", input);
      if (response) {
        let data = response.data.ports;
        this.ports = data;
      }
    },
    async getParentVesselTypes() {
      let input = {
        only_parents: true,
      };
      let response = await this.getHTTPPostResponse("vesselType/list", input);
      if (response) {
        let vesselTypes = response.data.vesselTypes;
        let filteredTypes = [];
        for (var i = 0; i < vesselTypes.length; i++) {
          let obj = { id: vesselTypes[i].id, name: vesselTypes[i].name };
          filteredTypes.push(obj);
        }
        this.parentVesselTypes = this.parentVesselTypes.concat(filteredTypes);
      }
    },
    async getSubtypes() {
      var input = {
        parent_id: this.parent_id,
      };
      let response = await this.getHTTPPostResponse("vesselType/list", input);
      if (response) {
        let data = response.data.vesselTypes;
        this.subtypes = data;
      }
    },
    async addEditVessel() {
      let input = {
        name: this.name,
        owner_id: this.owner,
        manager_id: this.manager,
        office_id: this.office,
        fleet_id: this.fleet,
        flag_id: this.country,
        port_id: this.port,
        imo_number: this.imo_number,
        type_id: this.parent_id,
        sub_type_id: this.subtype,
        is_active: this.is_active,
      };
      if (!this.folders.length) {
        this.$vs.notify({
          title: "Error.",
          text: "Please create master folders for this vessel sub type",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (!this.editRoute) {
        this.createVessel(input);
      } else {
        this.updateVessel(input);
      }
    },
    async createVessel(input) {
      const childData = this.$refs.inspectionImg.sections;
      const hasRedPin = childData.some(
        (section) =>
          (section.location && section.location.color === "red") ||
          section.subFolders.some(
            (subfolder) =>
              subfolder.location && subfolder.location.color === "red"
          )
      );
      if (hasRedPin) {
        this.$vs.notify({
          title: "Error.",
          text: "Please map the folder location",
          color: "danger",
          position: "top-right",
        });
        return;
      } else {
        const finalPayload = childData.map((v) => ({
          folder_name: v.folder_name,
          folder_id: v.id || null,
          imageBlob: v.file || null,
          location: v.location
            ? JSON.stringify({ x: v.location.x, y: v.location.y })
            : null,
          ga_plan_image: v.file ? null : v.ga_plan_image,
          subFolders: v.subFolders.map((subfolder) => {
            const location =
              subfolder.location && subfolder.location.color != "red"
                ? subfolder.location
                : null;
            return {
              sub_folder_id: subfolder.id || null,
              folder_name: subfolder.folder_name,
              location: location
                ? JSON.stringify({ x: location.x, y: location.y })
                : null,
            };
          }),
        }));

        input = {
          ...input,
          is_active: input.is_active.toString(),
        };

        if (!finalPayload.length) {
          this.showError("Folder Payload Not Found");
          return;
        }

        const formData = new FormData();
        for (const key in input) {
          if (Object.hasOwnProperty.call(input, key)) {
            const element = input[key];
            formData.append(key, element);
          }
        }
        finalPayload.forEach((folder, folder_index) => {
          formData.append(
            `folders[${folder_index}][folder_name]`,
            folder.folder_name
          );
          if (folder.folder_id)
            formData.append(
              `folders[${folder_index}][folder_id]`,
              folder.folder_id
            );
          if (folder.imageBlob)
            formData.append(
              `folders[${folder_index}][imageBlob]`,
              folder.imageBlob
            );
          if (folder.ga_plan_image)
            formData.append(
              `folders[${folder_index}][ga_plan_image]`,
              folder.ga_plan_image
            );

          if (folder.location)
            formData.append(
              `folders[${folder_index}][location]`,
              folder.location
            );

          folder.subFolders.forEach((subfolder, subFolderIndex) => {
            formData.append(
              `folders[${folder_index}][subFolders][${subFolderIndex}][folder_name]`,
              subfolder.folder_name
            );
            if (subfolder.location)
              formData.append(
                `folders[${folder_index}][subFolders][${subFolderIndex}][location]`,
                subfolder.location
              );
          });
        });

        let url = "/vessels/create";
        let response = await this.getHTTPPostResponse(
          url,
          formData,
          "#vessel-add-edit",
          true
        );
        this.$refs.inspectionImg.resetFormDirty();
        if (response && response.status == 200) {
          history.back();
        }
      }
    },
    async updateVessel(input) {
      const childData = this.$refs.inspectionImg.sections;
      const hasRedPin = childData.some(
        (section) =>
          (section.location && section.location.color === "red") ||
          section.subFolders.some(
            (subfolder) =>
              subfolder.location && subfolder.location.color === "red"
          )
      );
      if (hasRedPin) {
        this.$vs.notify({
          title: "Error.",
          text: "Please map the folder location",
          color: "danger",
          position: "top-right",
        });
        return;
      } else {
        const finalPayload = childData.map((v) => ({
          folder_name: v.folder_name,
          id: v.id || null,
          imageBlob: v.file || null,
          location: v.location
            ? JSON.stringify({ x: v.location.x, y: v.location.y })
            : null,
          ga_plan_image: v.file ? null : v.ga_plan_image,
          subFolders: v.subFolders.map((subfolder) => {
            const location =
              subfolder.location && subfolder.location.color != "red"
                ? subfolder.location
                : null;
            return {
              id: subfolder.id || null,
              folder_name: subfolder.folder_name,
              location: location
                ? JSON.stringify({ x: location.x, y: location.y })
                : null,
            };
          }),
        }));
        if (!finalPayload.length) {
          this.showError("Folder Payload Not Found");
          return;
        }
        input = {
          ...input,
          is_active: input.is_active.toString(),
        };
        const formData = new FormData();
        for (const key in input) {
          if (Object.hasOwnProperty.call(input, key)) {
            const element = input[key];
            formData.append(key, element);
          }
        }

        finalPayload.forEach((folder, folder_index) => {
          if (folder.id) {
            formData.append(`folders[${folder_index}][id]`, folder.id);
          }
          formData.append(
            `folders[${folder_index}][folder_name]`,
            folder.folder_name
          );
          if (folder.folder_id)
            formData.append(
              `folders[${folder_index}][folder_id]`,
              folder.folder_id
            );
          if (folder.imageBlob)
            formData.append(
              `folders[${folder_index}][imageBlob]`,
              folder.imageBlob
            );

          if (folder.ga_plan_image)
            formData.append(
              `folders[${folder_index}][ga_plan_image]`,
              folder.ga_plan_image
            );

          formData.append(
            `folders[${folder_index}][location]`,
            folder.location
          );

          folder.subFolders.forEach((subfolder, subFolderIndex) => {
            if (subfolder.id) {
              formData.append(
                `folders[${folder_index}][subFolders][${subFolderIndex}][id]`,
                subfolder.id
              );
            }
            formData.append(
              `folders[${folder_index}][subFolders][${subFolderIndex}][folder_name]`,
              subfolder.folder_name
            );
            formData.append(
              `folders[${folder_index}][subFolders][${subFolderIndex}][location]`,
              subfolder.location
            );
          });
        });

        let url = "/vessels/update/" + this.editRoute;
        let response = await this.getHTTPPostResponse(
          url,
          formData,
          "#vessel-add-edit",
          true
        );
        if (response) {
          history.back();
        }
      }
    },
    async getVessels() {
      this.$vs.loading();
      let response = await this.getHTTPGetResponse(
        "/vessels/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let vessel = data.vessel;
        if (!vessel) return;
        this.owner = vessel.owner_id;
        this.manager = vessel.manager_id;
        this.office = vessel.office_id;
        this.fleet = vessel.fleet_id;
        this.subtype = vessel.sub_type_id;
        this.country = vessel.flag_id;
        this.port = vessel.port_id;
        this.name = vessel.name;
        this.is_active = vessel.is_active;
        this.parent_id = vessel.type_id;
        this.imo_number = vessel.imo_number;
      }
      this.$vs.loading.close();
    },
    createNewClient(type) {
      if (type == "OW") this.ownerPopupActive = true;
      if (type == "M") this.managerPopupActive = true;
      if (type == "OF") this.officePopupActive = true;
      if (type == "F") this.fleetPopupActive = true;
    },
    goBack() {
      history.back();
    },
    closePopup(type) {
      this.ownerPopupActive = false;
      this.getOwners();
      this.owner = type.id;
    },
    closePopupManager(type) {
      this.managerPopupActive = false;
      this.getManagers();
      this.manager = type.id;
    },
    closePopupOffice(type) {
      this.officePopupActive = false;
      this.getOffices();
      this.office = type.id;
    },
    closePopupFleet(type) {
      this.fleetPopupActive = false;
      this.getFleets();
      this.fleet = type.id;
    },
  },
};
</script>
<style>
.parent_is_valid {
  color: rgba(var(--vs-danger), 1);
  font-size: 0.875rem !important;
  margin-left: 1px;
}

.image-container {
  position: relative;
}

h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1);
}

.attachment-border {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 9px;
}

.cancel-file {
  align-self: center;
}

.vessel_is_valid {
  color: rgba(var(--vs-danger), 1);
  margin-left: 1px;
}

.skip_position {
  margin-top: -1px;
  margin-left: 535px;
  cursor: pointer;
}

.popup-1 .vs-popup--close {
  position: absolute;
  display: flex;
  padding: 8px;
  cursor: pointer;
  margin-top: -46px;
  margin-left: 533px;
  margin-right: 20px;
  -webkit-transform: translate(8px, -8px);
  transform: translate(8px, -8px);
  background: rgb(115, 194, 251);
  font-size: 17px;
  color: rgba(0, 0, 0, 0.6);
}

.save_vessel {
  margin-left: 250px;
  margin-top: 30px;
}

.btn-link {
  background: none !important;
  border: none;
  color: #04497c;
  padding: 0 !important;
  font-family: arial, sans-serif;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 8px;
  font-size: 15px;
}

.pin {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  transition: transform 0.3s ease, filter 0.3s ease;
  /* cursor: pointer; */
  cursor: grab;

  /* position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer; */
}

.zoom-effect {
  transition: transform 0.3s ease, filter 0.3s ease;
  cursor: pointer;
}

.zoom-effect:hover {
  transform: scale(1.05);
}

.yellow-pin::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 30px;
  height: 30px;
  background-color: #ec9a29;
  border-radius: 50% 50% 50% 0;
  z-index: -1;
}

.red-pin::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 30px;
  height: 30px;
  background-color: red;
  border-radius: 50% 50% 50% 0;
  z-index: -1;
}

.marker {
  position: absolute;
  background-color: red;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.legend {
  position: absolute;
  top: 0;
  right: 0;
  margin-right: 25px;
  margin-top: 35px;
  background-color: #e1e2e5;
  padding: 10px;
  border: 2px solid black;
  border-radius: 5px;
  padding-right: 20px;
}

.legend-item {
  color: black;
  font-family: "Arial", sans-serif;
  font-weight: bold;
  font-size: 12px;
}
.folder-name {
  height: 50px;
  display: flex;
  align-items: center;
}
.delete-image {
  top: 5px;
  right: 0px;
}
</style>
